"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Spa;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Spa(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Facilities"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "spa"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M48.79,33.579c.138,0,.258-.005.353-.01,4.827.12,6.973-1.931,7.915-3.673C60.5,23.537,52.673,11.79,51.07,9.5a2.529,2.529,0,0,0-3.008-.927,2.446,2.446,0,0,0-1.517,2.691c.1,1.187-.464,8.455-1.57,10.68-2.077,4.18-2.352,7.262-.842,9.421A5.591,5.591,0,0,0,48.79,33.579Zm.663-9.411a19.738,19.738,0,0,0,1.391-5.085c1.641,3.493,2.646,6.9,1.815,8.435-.509.941-2.181,1.091-3.5,1.049a2.216,2.216,0,0,0-.355.015,1.8,1.8,0,0,1-.573-.075C48.23,28.5,47.8,27.5,49.453,24.168Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M71.59,44.814a2.39,2.39,0,0,0-.079-.347c-.162-.533-1.838-5.265-10.643-7.37A38.313,38.313,0,0,0,50,35.775,38.262,38.262,0,0,0,39.132,37.1c-8.8,2.1-10.481,6.837-10.643,7.37a2.39,2.39,0,0,0-.079.347c-3.717,24.154,1.7,40.808,1.932,41.505a2.493,2.493,0,0,0,.8,1.156C36.056,91.434,45.917,91.648,50,91.553c.409.009.875.015,1.389.015,4.618,0,13.047-.53,17.467-4.093a2.5,2.5,0,0,0,.8-1.156C69.891,85.622,75.307,68.968,71.59,44.814ZM65.135,84c-3.271,2.07-10.039,2.679-15.073,2.556h-.124c-5.031.124-11.8-.485-15.075-2.558-.962-3.39-4.578-18.077-1.561-38.1.3-.54,1.817-2.7,6.993-3.938a32.781,32.781,0,0,1,9.523-1.186,2.212,2.212,0,0,0,.364,0,32.806,32.806,0,0,1,9.523,1.186c5.176,1.237,6.688,3.4,6.993,3.938C69.705,65.852,66.092,80.6,65.135,84Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M63.537,47.45c-13.142,4.751-26.855.045-26.992,0a1.5,1.5,0,0,0-1,2.829A49.158,49.158,0,0,0,50.6,52.6a41.085,41.085,0,0,0,13.958-2.326,1.5,1.5,0,0,0-1.02-2.822Z"
  })))));
}